module.exports = __webpack_public_path__ + "static/media/submit-btn.755cab12.png";